// extracted by mini-css-extract-plugin
export default {"letter":"styles_letter__8BILF","highlighted":"styles_highlighted__aPi7w"};